import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';

import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Card, Col, Row, Spinner, Button } from 'react-bootstrap';


import ModalDatosFiscales from './ModalDatosFiscales';

import { useNavigate } from 'react-router-dom';


const ListaDatosFacturacion = (
    {
        showModalNuevo,   
        setShowModalNuevo, 
        showModalDatosFiscales,   
        setShowModalDatosFiscales
    }
) => {

    const { showErrorToast } = useToast();

    /**
    * Variable to show products  
    */
    // 
    const columns = [
        {
            accessor: 'idDatoFiscal',
            Header: 'ID',
            cellProps: { className: 'ps-2 text-center' },
            width: 80,
            Cell: rowData => {
                const { idDatoFiscal } = rowData.row.original;
                return (
                    <span
                        className="text-primary fw-semi-bold cursor-pointer"
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            // Abre el modal
                            ObtenerDatoFiscalDetalle(idDatoFiscal);
                            setShowModalNuevo(false);
                        }}
                    >
                        <img title="Ver informaci&oacute;n" src="/img/ver20.png"></img >
                    </span>
                );
            }
        },
        {
            accessor: 'datoFiscal',
            Header: 'ID',
            cellProps: { className: 'ps-2 text-truncate' },
            width: 80, 
            Cell: rowData => {
                const { idDatoFiscal } = rowData.row.original;
                return (
                    <span
                        className="text-primary fw-semi-bold cursor-pointer"
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            // Abre el modal
                            ObtenerDatoFiscalDetalle(idDatoFiscal);
                            
                            setShowModalNuevo(false);
                        }}
                    >
                        {idDatoFiscal}
                    </span>
                );
            }
        },
        {
            accessor: 'vRazonSocial',
            Header: 'Razon Social',
            cellProps: {
                className: 'ps-2 text-truncate',
                style: { maxWidth: '200px' } 
            },
            Cell: rowData => (
                <span className="text-dark text-truncate">
                    <strong>{rowData.row.original.vRazonSocial}</strong>
                </span>
            )
        },
        {
            accessor: 'vRFC',
            Header: 'RFC',
            cellProps: { className: 'ps-2 text-truncate' },
            width: 130, 
            Cell: rowData => (
                <span className="text-dark text-truncate">
                    <strong>{rowData.row.original.vRFC}</strong>
                </span>
            )
        },
        {
            accessor: 'vCP',
            Header: 'CP',
            cellProps: { className: 'ps-2 text-truncate' },
            width: 130,
            Cell: rowData => (
                <span className="text-dark text-truncate">
                    <strong>{rowData.row.original.vCP}</strong>
                </span>
            )
        },
        {
            Header: 'Regimen Fiscal',
            cellProps: {
                className: 'ps-2 text-truncate align-middle',
                style: {
                    maxWidth: '150px',
                    lineHeight: 'normal' // Asegura misma altura de línea
                }
            },
            width: 130,
            Cell: rowData => (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip>
                            <strong>{rowData.row.original.vCodeRegimen}</strong>
                            <br />
                            {rowData.row.original.vDescripcionRegimenFiscal}
                        </Tooltip>
                    }
                >
                    <div
                        className="text-truncate w-100"
                        style={{
                            verticalAlign: 'middle', // Alineación vertical explícita
                            lineHeight: '1.5' // Igualar al line-height de otras celdas
                        }}
                    >
                        <span className="fw-semibold text-dark">
                            {rowData.row.original.vCodeRegimen}
                        </span>
                        <span className="text-dark">
                            {` - ${rowData.row.original.vDescripcionRegimenFiscal}`}
                        </span>
                    </div>
                </OverlayTrigger>
            )
        },
        {
            accessor: 'vArchivoCER_Name',
            Header: 'Archivo CER',
            cellProps: { className: 'ps-2 align-middle' },
            width: 110,
            Cell: rowData => {
                const datosFila = rowData.row.original;

                const handleDescarga = () => {
                    // Convertir solo cuando se hace clic
                    const archivoConvertido = base64ToFile(
                        datosFila.vArchivoCER_Base64,
                        datosFila.vArchivoCER_Name
                    );
                    descargarArchivoCER(archivoConvertido);
                };

                return (
                    <Button
                        variant="link"
                        size="sm"
                        className="p-0 text-decoration-none"
                        onClick={handleDescarga}
                    >
                        <span className="fw-semi-bold text-primary">
                            {datosFila.vArchivoCER_Name}
                        </span>
                    </Button>
                );
            }
        },
        {
            accessor: 'vArchivoKEY_Name',
            Header: 'Archivo KEY',
            cellProps: { className: 'ps-2 align-middle' },
            width: 110,
            Cell: rowData => {
                const datosFila = rowData.row.original;

                const handleDescarga = () => {
                    const archivoConvertido = base64ToFile(
                        datosFila.vArchivoKEY_Base64,
                        datosFila.vArchivoKEY_Name
                    );
                    descargarArchivoCER(archivoConvertido); // O crear función similar para KEY
                };

                return (
                    <Button
                        variant="link"
                        size="sm"
                        className="p-0 text-decoration-none"
                        onClick={handleDescarga}
                    >
                        <span className="fw-semi-bold text-primary">
                            {datosFila.vArchivoKEY_Name}
                        </span>
                    </Button>
                );
            }
        }
    ];

    const { token, setToken, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();

    const [datosFicales, setDatosFiscales] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [datoFiscal, setDatoFiscal] = useState({})
    const [lista, setLista] = useState(false);

    
    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();
    }, [lista]);

    /**
  * Verifica los permisos
  */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {

                obtenerDatosFiscales();


            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }

    /**
    * Obtiene los Formas Pago
    */
    const ObtenerDatoFiscalDetalle = async (id) => {

        setCargando(true);

        var objDataSend = {};
        console.log(id, 'ID DEL DATO FISCAL VERDADERO');
        objDataSend.idDatoFiscal = id;
        console.log(objDataSend, 'ID DEL DATO FISCAL EN VARIABLE');
        var jDataSend = JSON.stringify(objDataSend);

        const response = await fetch("/api/Contabilidad/EditarDatoFiscal", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response.ok) {

            console.log("===================== informacionEditarDatosFiscales =========================");
            console.log(response);
            const data = await response.json();
            console.log("===================== RESPONSETYPE =========================", data);

            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                setDatoFiscal(ObjDetalles.table2[0]);
                console.log("INFORMACION DE DATOS FISCALES", ObjDetalles.table2[0])
                setShowModalNuevo(false);

                setShowModalDatosFiscales(true);
                
            } else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);
    };
    /**
     * Obtiene los datos fiscales
     */
    const obtenerDatosFiscales = async () => {

        setCargando(true)

        const response = await fetch("/api/Contabilidad/obtenerDatosFiscales",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            console.log("==== OBTENER DATOS FISCALES ====");

            const data = await response.json();

            if (data.iResponseType == 1) {


                var ObjDetalles = JSON.parse(data.detalles);

                console.log("obtenerDatosFiscales", ObjDetalles);
                setDatosFiscales(ObjDetalles.table2)

            } else {
                showErrorToast(data.vMessage);
            }
            setCargando(false);



        }
        else {
            setCargando(true);
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Convertir Base64 a archivo
     */
    const base64ToFile = (base64String, fileName) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });

        return new File([blob], fileName, { type: blob.type });
    };


    /**
    * Descargar Archivo CER
    */
    const descargarArchivoCER = (file) => {

        console.log("FILE", file);

        // Crea un objeto Blob a partir del archivo
        const blob = new Blob([file], { type: file.type });

        // Crea un enlace de descarga
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = file.name;

        // Haz clic en el enlace para iniciar la descarga
        link.click();

        // Libera la URL del objeto después de la descarga
        URL.revokeObjectURL(link.href);

    };



    return (
        <>
            <AdvanceTableWrapper
                columns={columns}
                data={datosFicales}

                sortable
                pagination
                perPage={15}
            >
                <Card className="mb-3">
                    <Card.Header >
                        <Row>
                            <Col className="ms-auto" sm={8} lg={4} xs={12} >

                                {!cargando &&
                                    <AdvanceTableSearchBox table />
                                }
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="p-0">

                        <AdvanceTable
                            table
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                className: 'fs--2 mb-0 overflow-hidden'
                            }}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter
                            rowCount={datosFicales.length}
                            table
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            {cargando && (<h5><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h5>)}

            {
                showModalDatosFiscales && 
                <>
                    <ModalDatosFiscales

                        showModalNuevo={showModalNuevo}
                        setShowModalNuevo={setShowModalNuevo}
                        showModalDatosFiscales={showModalDatosFiscales}
                        setShowModalDatosFiscales={setShowModalDatosFiscales}

                        datoFiscal={datoFiscal}
                        setLista={setLista}
                        lista={lista}
                    />
                </>

            }

        </>

    );
};

ListaDatosFacturacion.propTypes = {

    setShowModalNuevo: PropTypes.func,
    showModalNuevo: PropTypes.bool,
    showModalDatosFiscales: PropTypes.bool, 
    setShowModalDatosFiscales: PropTypes.func

};



export default ListaDatosFacturacion;
